<template>
  <p class="text-gray-400 text-center my-6"> Made with <span class="text-team-red">❤</span> by Miko</p>
</template>

<script>
export default {
  name: 'Footer'
}
</script>
